import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { baseLegalEntityInputsConfig } from 'features/new-actor/form/inputs-config/baseLegalEntityInputsConfig';
import { personalInformationInputsConfig } from 'features/new-actor/form/inputs-config/personalInformationInputsConfig';
import { InputsConfig } from 'types/form/inputsConfig';
import {
  BorrowerInsuredFormFieldNames,
  BorrowerLegalFormValues
} from '../borrowerInsuredForm';

export const borrowerLegalInputsConfig: InputsConfig<
  Exclude<keyof BorrowerLegalFormValues, 'id'>
> = {
  ...personalInformationInputsConfig,
  ...addressInputsConfig,
  ...baseLegalEntityInputsConfig,

  [LegalEntityFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.InputText,
    name: LegalEntityFormFieldNames.CompanyName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.COMPANY_NAME'
  },

  [LegalEntityFormFieldNames.CompanyRole]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.CompanyRole,
    name: LegalEntityFormFieldNames.CompanyRole,
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.COMPANY_ROLE',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.COMPANY_ROLE'
  },

  [BorrowerInsuredFormFieldNames.SurveyForm]: {
    componentKey: ComponentKey.Custom,
    name: BorrowerInsuredFormFieldNames.SurveyForm
  },

  [BorrowerInsuredFormFieldNames.ProspectType]: {
    componentKey: ComponentKey.Dropdown,
    name: BorrowerInsuredFormFieldNames.ProspectType,
    required: true,
    label: 'BORROWER_INSURED_FORM.LABELS.PROSPECT_TYPE',
    items: [
      { key: 'borrower', label: 'BORROWER.COMMON.BORROWER' },
      { key: 'coborrower', label: 'BORROWER.COMMON.COBORROWER' },
      { key: 'cosigner', label: 'BORROWER.COMMON.COSIGNER' }
    ]
  },

  [BorrowerInsuredFormFieldNames.IsFPE]: {
    componentKey: ComponentKey.Checkbox,
    name: BorrowerInsuredFormFieldNames.IsFPE,
    required: true,
    label: 'BORROWER_INSURED_FORM.LABELS.IS_FPE'
  },

  [BorrowerInsuredFormFieldNames.Job]: {
    componentKey: ComponentKey.InputText,
    name: BorrowerInsuredFormFieldNames.Job,
    type: 'text',
    required: true,
    label: 'BORROWER_INSURED_FORM.LABELS.JOB',
    placeholder: 'BORROWER_INSURED_FORM.LABELS.JOB_PLACEHOLDER'
  },

  [BorrowerInsuredFormFieldNames.BorrowerId]: {
    componentKey: ComponentKey.Custom,
    name: BorrowerInsuredFormFieldNames.BorrowerId
  }
};
